const frequencies = [
  { code: 'Q', multiplier: 3, name: 'Quarterly' },
  { code: 'S', multiplier: 6, name: 'Semiannually' },
  { code: 'A', multiplier: 12, name: 'Annually' }
];

export default frequencies;
